import * as types from './mutation-types'

export default {
  [types.ADD_TWILIO](state, data) {
    state.twilio = data
  }
  
}
